import {
  Activity,
  BarChart3,
  BellRing,
  Building2,
  CalendarCheck,
  FileSignature,
  FlaskConical,
  Gift,
  Landmark,
  MessageCircle,
  Package,
  Palette,
  ScanLine,
  ShieldCheck,
  Wallet,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { PlanFeatureKey } from '@/api/billing.api';
import { settingsSectionPath } from '@/routes/route-config';

/** The billing page with the Change plan window open on `planId`. */
export function upgradePath(planId?: number | null) {
  const base = settingsSectionPath('subscription');
  return `${base}?changePlan=${planId ?? 'open'}`;
}

/** The icon each plan feature is shown with on locked screens and plan cards. */
export const PLAN_FEATURE_ICONS: Record<PlanFeatureKey, LucideIcon> = {
  online_booking: CalendarCheck,
  financial_statements: Landmark,
  payroll: Wallet,
  insurance: ShieldCheck,
  inventory: Package,
  lab_cases: FlaskConical,
  xray_import: ScanLine,
  auto_recalls: BellRing,
  consent_esign: FileSignature,
  clinic_analytics: BarChart3,
  loyalty_offers: Gift,
  staff_chat: MessageCircle,
  branch_reports: Building2,
  activity_log: Activity,
  custom_branding: Palette,
};
